// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

/* Colonne contenu + footer. Le contenu remplit au moins la hauteur d'ecran pour que le
   footer reste SOUS la ligne de flottaison (il ne doit pas depasser pendant le skeleton de
   chargement) ; il devient visible au scroll ou quand le contenu est plus long que l'ecran. */
.app-layout-main {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}
/* Pas de flex-grow : le footer suit le contenu, il n'est pas colle au bas du viewport. */
.app-layout-main > .main-content {
  flex: 0 0 auto;
}
/* Le contenu occupe au moins tout l'ecran -> le footer demarre au pied de page (hors viewport). */
.main-content--topnav,
.main-content.sidebar-collapsed {
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  margin-left: 117px;
  width: calc(100% - 117px);
  background-color: rgba(215, 217, 217, 0.25);
}

/* Decalage sous la barre d'en-tete fixe (UserInfo, 64px) + 2rem d'inset haut. */
.main-content.has-header {
  padding-top: calc(64px + 2rem);
}

/* Marges uniformes du contenu (6rem) portees par le conteneur global.
   Les pages ne portent plus leur propre padding (sinon double). */
.main-content.sidebar-collapsed,
.main-content.main-content--topnav {
  padding-left: 6rem;
  padding-right: 6rem;
  padding-bottom: 6rem;
}

/* Logo de marque : tuile fixe en haut a gauche, immobile. Bord gauche aligne sur
   l'inset des titres de page (6rem). */
.app-brand-logo {
  position: fixed;
  top: 0;
  left: 0;
  height: 64px;
  display: flex;
  align-items: center;
  padding-left: 6rem;
  z-index: 1001;
}
.app-brand-logo svg {
  height: 22px;
  width: auto;
  display: block;
}

.main-content.sidebar-collapsed {
  margin-left: 64px;
  width: calc(100% - 64px);
  transition:
    margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Mode sidebar : au survol de la sidebar repliee, elle se deploie ET pousse le contenu.
   .main-content est desormais imbrique dans .app-layout-main -> on traverse le wrapper
   (sinon le combinateur ~ ne trouve plus .main-content comme frere de .sidebar). */
.sidebar:hover ~ .app-layout-main .main-content {
  margin-left: 117px;
  width: calc(100% - 117px);
}
.sidebar:hover ~ .app-layout-main .user-info-display {
  left: 117px;
}

/* Page d'accueil / auth : pas de sidebar ni d'en-tete, contenu pleine largeur. */
.main-content.main-content--full {
  margin-left: 0;
  width: 100%;
}

/* Mode top-nav : sidebar desactivee -> contenu et navbar pleine largeur. */
.main-content.main-content--topnav {
  margin-left: 0;
  width: 100%;
}
.app-layout--topnav .user-info-display {
  left: 0;
}

/* Pages de suivi / candidature : pleine largeur (banner header). On annule l'inset
   et on colle le contenu sous la navbar -> layout existant preserve. */
.main-content.main-content--bleed {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}
.main-content.main-content--bleed.has-header {
  padding-top: 64px;
}
`, "",{"version":3,"sources":["webpack://./src/Layout/MainLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;8FAE8F;AAC9F;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;AACA,yFAAyF;AACzF;EACE,cAAc;AAChB;AACA,kGAAkG;AAClG;;EAEE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,gFAAgF;AAChF;EACE,8BAA8B;AAChC;;AAEA;kEACkE;AAClE;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;uCACuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB;;2CAEyC;AAC3C;;AAEA;;mFAEmF;AACnF;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA,iFAAiF;AACjF;EACE,cAAc;EACd,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,OAAO;AACT;;AAEA;uEACuE;AACvE;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".app-layout {\n  display: flex;\n  min-height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n/* Colonne contenu + footer. Le contenu remplit au moins la hauteur d'ecran pour que le\n   footer reste SOUS la ligne de flottaison (il ne doit pas depasser pendant le skeleton de\n   chargement) ; il devient visible au scroll ou quand le contenu est plus long que l'ecran. */\n.app-layout-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n/* Pas de flex-grow : le footer suit le contenu, il n'est pas colle au bas du viewport. */\n.app-layout-main > .main-content {\n  flex: 0 0 auto;\n}\n/* Le contenu occupe au moins tout l'ecran -> le footer demarre au pied de page (hors viewport). */\n.main-content--topnav,\n.main-content.sidebar-collapsed {\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  margin-left: 117px;\n  width: calc(100% - 117px);\n  background-color: rgba(215, 217, 217, 0.25);\n}\n\n/* Decalage sous la barre d'en-tete fixe (UserInfo, 64px) + 2rem d'inset haut. */\n.main-content.has-header {\n  padding-top: calc(64px + 2rem);\n}\n\n/* Marges uniformes du contenu (6rem) portees par le conteneur global.\n   Les pages ne portent plus leur propre padding (sinon double). */\n.main-content.sidebar-collapsed,\n.main-content.main-content--topnav {\n  padding-left: 6rem;\n  padding-right: 6rem;\n  padding-bottom: 6rem;\n}\n\n/* Logo de marque : tuile fixe en haut a gauche, immobile. Bord gauche aligne sur\n   l'inset des titres de page (6rem). */\n.app-brand-logo {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  padding-left: 6rem;\n  z-index: 1001;\n}\n.app-brand-logo svg {\n  height: 22px;\n  width: auto;\n  display: block;\n}\n\n.main-content.sidebar-collapsed {\n  margin-left: 64px;\n  width: calc(100% - 64px);\n  transition:\n    margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n    width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Mode sidebar : au survol de la sidebar repliee, elle se deploie ET pousse le contenu.\n   .main-content est desormais imbrique dans .app-layout-main -> on traverse le wrapper\n   (sinon le combinateur ~ ne trouve plus .main-content comme frere de .sidebar). */\n.sidebar:hover ~ .app-layout-main .main-content {\n  margin-left: 117px;\n  width: calc(100% - 117px);\n}\n.sidebar:hover ~ .app-layout-main .user-info-display {\n  left: 117px;\n}\n\n/* Page d'accueil / auth : pas de sidebar ni d'en-tete, contenu pleine largeur. */\n.main-content.main-content--full {\n  margin-left: 0;\n  width: 100%;\n}\n\n/* Mode top-nav : sidebar desactivee -> contenu et navbar pleine largeur. */\n.main-content.main-content--topnav {\n  margin-left: 0;\n  width: 100%;\n}\n.app-layout--topnav .user-info-display {\n  left: 0;\n}\n\n/* Pages de suivi / candidature : pleine largeur (banner header). On annule l'inset\n   et on colle le contenu sous la navbar -> layout existant preserve. */\n.main-content.main-content--bleed {\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n}\n.main-content.main-content--bleed.has-header {\n  padding-top: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
